<div class="folder-main">
    <div class="folder-menus">
        <div class="menus" *ngFor="let list of data;let index = index">
            <div class="folder-name">
                <i class="bi bi-folder-fill" (click)="openFolder(list)" ></i><p class="name">{{list.label}}</p>
            </div>
            <div *ngIf="list.isOpen">
                <app-sub-menu [list]="list.children"></app-sub-menu>
            </div>
            
        </div>
    </div>
</div>